import {useMemo, useState} from "react";
import {SchedulePeriod} from "./types";
import dayjs, {Dayjs} from "dayjs";
import {buildOperationTimeQueries} from "./helpers/buildOperationTimeQueries";
import {Query} from "appwrite";
import {useSurgeryRequestsController} from "../../controllers/surgeryRequests-controller";
import {SurgeryRequestItem} from "../../types/surgeryRequests";
import useOperationRoomsController from "../../controllers/operationRooms-controller";

const useSurgerySchedulePageService = () => {

  const [period, setPeriod] = useState<SchedulePeriod>('month')
  const [selectedDate, setSelectedDate] = useState<Dayjs>(dayjs())
  const {operationRoomsList} = useOperationRoomsController()

  const queries = useMemo(
    () => [
      ...buildOperationTimeQueries({
        period,
        selectedDate,
      }),
      Query.orderAsc('operationTime'),
    ],
    [period, selectedDate],
  )

  const surgeryRequestsController = useSurgeryRequestsController({queries})
  const {list, isLoading, isDetailsModalOpen, detailsButtonHandler} = surgeryRequestsController


  const groupedByRoom = useMemo(() => {
    return list.reduce<Record<string, SurgeryRequestItem[]>>(
      (acc, item) => {
        const roomId = item.operationRoom?.$id ?? 'without-room'

        if (!acc[roomId]) {
          acc[roomId] = []
        }

        acc[roomId].push(item)

        return acc
      },
      {},
    )
  }, [list])

  return {
    period,
    setPeriod,
    selectedDate,
    setSelectedDate,
    list,
    isLoading,
    groupedByRoom,
    operationRoomsList,
    isDetailsModalOpen,
    detailsButtonHandler,
    surgeryRequestsController
  }
}

export default useSurgerySchedulePageService